import { apiUrl, authFetch, currentAuthUser, saveAuth } from "./api";

export const AVATAR_EVENT = "sonne:avatar";
const SIZE = 256;

// Bild mittig quadratisch zuschneiden und auf 256 px verkleinern (JPEG) –
// spart Speicher und lädt schnell, egal wie groß das Handyfoto ist.
async function squareJpeg(file: File): Promise<Blob> {
  const bitmap = await createImageBitmap(file);
  const side = Math.min(bitmap.width, bitmap.height);
  const canvas = document.createElement("canvas");
  canvas.width = SIZE;
  canvas.height = SIZE;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Bild konnte nicht verarbeitet werden.");
  ctx.drawImage(bitmap, (bitmap.width - side) / 2, (bitmap.height - side) / 2, side, side, 0, 0, SIZE, SIZE);
  bitmap.close?.();
  return new Promise((resolve, reject) =>
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error("Bild konnte nicht verarbeitet werden."))), "image/jpeg", 0.88));
}

async function send(businessId: number | string, membershipId: number | string, init: RequestInit): Promise<string | null> {
  const response = await authFetch(apiUrl(`/api/v1/businesses/${businessId}/users/${membershipId}/avatar`), init);
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(Array.isArray(body.errors) ? body.errors.join(" ") : "Profilbild konnte nicht gespeichert werden.");
  return body.avatar_url ?? null;
}

// Eigenes Bild geändert → gespeicherten Login-Nutzer aktualisieren (Seitenleiste).
function syncOwn(userId: string | number | undefined, url: string | null) {
  const me = currentAuthUser();
  if (!me || userId == null || String(me.id) !== String(userId)) return;
  saveAuth({ ...me, avatar_url: url });
  window.dispatchEvent(new CustomEvent(AVATAR_EVENT));
}

export async function uploadAvatar(businessId: number | string, membershipId: number | string, userId: string | number | undefined, file: File) {
  if (!file.type.startsWith("image/")) throw new Error("Bitte eine Bilddatei auswählen.");
  const form = new FormData();
  form.append("avatar", await squareJpeg(file), "avatar.jpg");
  const url = await send(businessId, membershipId, { method: "POST", body: form });
  syncOwn(userId, url);
  return url;
}

export async function removeAvatar(businessId: number | string, membershipId: number | string, userId: string | number | undefined) {
  await send(businessId, membershipId, { method: "DELETE" });
  syncOwn(userId, null);
  return null;
}
